module.exports = __webpack_public_path__ + "static/img/more-2.2fb6c802.png";